<template>
  <table class="action-prop-table">
    <tr>
      <th>quest</th>
      <td>{{questProtoId | getProtoAlias}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'PlayerPendingInfoRewindStoryToQuest',

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  computed: {
    questProtoId() {
      const payload = JSON.parse(this.pending.payload_json);
      return payload.quest_id;
    },
  },
}
</script>
